import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaWallet, FaEdit, FaTrash } from "react-icons/fa";
import { getVendorPaymentHistory } from '../../redux/services/SubscriptionServices/Subscription.Services';
import Pagination from '../../common/Pagination';
import Search from '../../common/Search';
import { errorToast } from '../../Utils/toast';
import { PAYMENT_STATUS_BADGE } from '../../Constant/leadConstent';

function PaymentList() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [tableLoading, setTableLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalAmount, setTotalAmount] = useState(0);

  const fetchPaymentList = async (pageNo = 1,searchValue = search) => {
    try {
      setTableLoading(true);
      const payload = {
       search: searchValue,
        page: pageNo,
        per_page: limit,
      };
      const res = await getVendorPaymentHistory(payload);
      const list = Array.isArray(res?.data) ? res.data : [];
      setPayments(list);
      setPage(res?.current_page ?? pageNo);
      setTotalPages(res?.last_page ?? 1);
      setTotalRecords(res?.total ?? list.length);
      setTotalAmount(res?.total_amount ?? 0);
    } catch (error) {
      console.log(error);
      errorToast('Failed to load payment transactions');
      setPayments([]);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentList(1);
  }, [limit, search]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && !tableLoading) {
      setPage(newPage);
      fetchPaymentList(newPage,search);
    }
  };
const handleSearch = (value) => {
  setSearch(value);
  setPage(1);
};


  const formatAmount = (val) => {
    if (val === null || val === undefined || val === '') return '-';
    return `₹${Number(val).toLocaleString('en-IN')}`;
  };

  const formatDate = (val) => {
    if (!val) return '-';
    return new Date(val).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
  <div>
         <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
         <div className="title_member">
           <h4>Payment List</h4>
           <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
             <span className="mx-2">/</span>
             <span>Payment List</span>
           </nav>
         </div>
         <div className="d-flex flex-wrap gap-2 justify-content-end">
             <div className="">
             <button className='add-btn' onClick={()=>navigate(-1)}> Back</button>
           </div>
           <div className="badge bg-success fs-6 py-2 px-3">
             Total Amount: {formatAmount(totalAmount)}
           </div>
        
         </div>
       </div>
      <div className="main_page">
        {(totalRecords > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
             <Search
    search={search}
    placeholder="Search by Transaction ID, Customer or Gateway..."
    onSearch={handleSearch}
  />
          </div>
        )}

        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                  <tr>
                        <th>#</th>
                        <th>Transaction ID</th>
                       
                        <th>Plan Name</th>
                        <th>Amount</th>
                        <th>Gateway</th>
                        <th>Mode</th>
                        <th>Status</th>
                        <th>Date</th>
                        {/* <th>Action</th> */}
                      </tr>
              </thead>
              <tbody>
                      {tableLoading ? (
                        <tr>
                          <td colSpan="10" className="text-center py-3">
                            <div className="spinner-border text-primary"></div>
                          </td>
                        </tr>
                      ) : payments.length > 0 ? (
                        payments.map((item, index) => (
                          <tr key={item.id || index}>
                            <td>{(page - 1) * limit + index + 1}</td>

                            {/* Transaction ID — fallback chain */}
                            <td>
                              {item.transaction_id ||
                                item.payment_id ||
                                item.order_id ||
                                '-'}
                            </td>
                          
                            <td className="text-start">
                              <div className="fw-bold">
                                {item.plan?.name || '-'}
                              </div>
                              {item.plan?.description && (
                                <small className="text-muted">
                                  {item.plan.description}
                                </small>
                              )}
                            </td>

                            {/* Amount — prefer total_amount, fallback amount */}
                            <td className="fw-bold text-success">
                              {formatAmount(item.total_amount ?? item.amount)}
                            </td>

                            {/* Gateway */}
                            <td>{item.payment_gateway || '-'}</td>

                            {/* Mode — payment_method */}
                            <td className="text-capitalize">
                              {item.payment_method || '-'}
                            </td>

                            {/* Status — using PAYMENT_STATUS_BADGE */}
                            <td>
                              <span
                                className={`badge ${
                                  PAYMENT_STATUS_BADGE[item.status] ||
                                  'badge-gray'
                                } text-capitalize`}
                              >
                                {item.status || '-'}
                              </span>
                            </td>

                            {/* Date */}
                            <td>{formatDate(item.created_at)}</td>

                            {/* Actions */}
                            {/* <td>
                              <div className="d-flex align-items-center justify-content-center gap-1">
                                <button
                                  className="st-action-btn st-view-btn"
                                  title="View Wallet Transactions"
                                  onClick={() => handleViewWallet(item)}
                                >
                                  <FaWallet />
                                </button>

                                

                             
                              </div>
                            </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center py-3">
                            No payment records found.
                          </td>
                        </tr>
                      )}
                    </tbody>
            </table>
            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
   
  );
}

export default PaymentList; 